import { makeAutoObservable } from "mobx"
import Country from "./Country"

export default class TripDestination {
  id?: number
  city: string
  countryId?: number
  regionId?: number
  delete: boolean

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.city = props.city || ""
    this.delete = false
    this.countryId = props.countryId || Country.unitedStates().id
    this.regionId = props.regionId
  }
}
